const ALERT_CONSTANTS = {
	SUCCESS: 'ALERT_SUCCESS',
	ERROR: 'ALERT_ERROR',
	SECONDARY: 'ALERT_SECONDARY',
	WARNING: 'ALERT_WARNING',
	CLEAR: 'ALERT_CLEAR',

	NO_INTERNET_CONNECTION: 'NO_INTERNET_CONNECTION',
}

const CART_CONSTANTS = {
	PHONE_NUMBER_REQUEST: 'SET_PHONE_NUMBER',

	CART_MENU_OPEN_REQUEST: 'CART_MENU_OPEN_REQUEST',
	CART_MENU_CLOSE_REQUEST: 'CART_MENU_CLOSE_REQUEST',

	UPDATE_CART_LOCALE_REQUEST: 'UPDATE_CART_LOCALE_REQUEST',

	SELECT_PRODUCT_ITEM: 'SELECT_PRODUCT_ITEM_REQUEST',
	SELECT_PRODUCT_VARIANT: 'SELECT_PRODUCT_VARIANT_REQUEST',
	UN_SELECT_PRODUCT_ITEM: 'UN_SELECT_PRODUCT_ITEM_REQUEST',

	CHANGE_CATEGORY_REQUEST: 'CHANGE_STORE_CATEGORY_DATA_REQUEST',
	CHANGE_CATEGORY_SUCCESS: 'CHANGE_CATEGORY_DATA_SUCCESS',
	CHANGE_CATEGORY_FAILURE: 'CHANGE_CATEGORY_DATA_FAILURE',

	LOAD_CART: 'LOAD_CART_REQUEST',
	ADD_ITEM_TO_CART: 'ADD_ITEM_TO_CART_REQUEST',
	REMOVE_ITEM_FROM_CART: 'REMOVE_ITEM_TO_CART_REQUEST',
	REMOVE_ITEM_FROM_PRODUCT_ITEM: 'REMOVE_ITEM_FROM_PRODUCT_ITEM_REQUEST',
	CHANGE_ITEM_QTY_IN_CART: 'CHANGE_ITEM_QTY_IN_CART_REQUEST',

	CLEAR_CART: 'CART_CLEAR_REQUEST',
	UPDATE_CART: 'CART_UPDATE_REQUEST',
	REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS:
		'REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS_REQUEST',
	CLEAR_ITEMS_IN_CART: 'CLEAR_ITEMS_IN_CART_REQUEST',

	CREATE_CATALOG_ORDER_REQUEST: 'CREATE_ORDER_CATALOG_REQUEST',
	CREATE_CATALOG_ORDER_SUCCESS: 'CREATE_ORDER_CATALOG_SUCCESS',
	CREATE_CATALOG_ORDER_FAILURE: 'CREATE_ORDER_CATALOG_FAILURE',
}

const CONFIG_CONSTANTS = {
	CUSTOM_CATALOG_DOMAIN_DEFAULT: 'CUSTOM_CATALOG_DOMAIN_DEFAULT',

	SET_APP_SETTINGS_TO_DEFAULT: 'REQUEST_APP_SETTINGS_TO_DEFAULT',

	SET_CATALOG_WITHOUT_PRODUCT_JOURNEY: 'SET_CATALOG_WITHOUT_PRODUCT_JOURNEY',
	EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY: 'EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY',

	STORE_CONFIGURATION_REQUEST: 'STORE_CONFIGURATION_DATA_REQUEST',
	STORE_CONFIGURATION_SUCCESS: 'STORE_CONFIGURATION_DATA_SUCCESS',
	UPDATED_STORE_CONFIGURATION_SUCCESS: 'UPDATED_STORE_CONFIGURATION_DATA_SUCCESS',
	STORE_CONFIGURATION_FAILURE: 'STORE_CONFIGURATION_DATA_FAILURE',

	STORE_CATALOG_INFO_REQUEST: 'STORE_CATALOG_INFO_DATA_REQUEST',
	STORE_CATALOG_INFO_SUCCESS: 'STORE_CATALOG_INFO_DATA_SUCCESS',
	STORE_CATALOG_INFO_FAILURE: 'STORE_CATALOG_INFO_DATA_FAILURE',

	STORE_CATALOG_INFO_DISABLE_RELOAD: 'DISABLE_RELOAD_STORE_CATALOG_INFO_DATA_REQUEST',

	EMPTY_CATALOG_CART_ITEMS: 'EMPTY_CATALOG_CART_ITEMS',

	CLEAR_SELECTED_CATEGORY: 'CLEAR_SELECTED_CATEGORY',
}

const STORE_CONSTANTS = {
	SHOP_LISTING_REQUEST: 'SHOP_LISTING_DATA_REQUEST',
	SHOP_LISTING_SUCCESS: 'SHOP_LISTING_DATA_SUCCESS',
	SHOP_LISTING_FAILURE: 'SHOP_LISTING_DATA_FAILURE',

	UPDATE_STORE_LISTING_PAGE: 'UPDATE_CURRENT_STORE_LISTING_PAGE_REQUESTED',
	ACCESS_NEW_STORE: 'ACCESS_NEW_STORE_REQUESTED',

	UPDATE_CURRENT_PRODUCT_PAGE: 'UPDATE_CURRENT_PRODUCT_PAGE',
	UPDATE_PAGE_INDEX: 'UPDATE_PAGE_INDEX',

	UPDATE_VISIBLE_STORE_PAGE_INDEX: 'UPDATE_VISIBLE_STORE_PAGE_INDEX',
	CLEAR_PAGE_NUMBER: 'CLEAR_PAGE_NUMBER',
	LOAD_MORE_STORES: 'LOAD_MORE_STORES',
}

const PRODUCT_CONSTANTS = {
	UPDATE_CURRENT_PRODUCT_PAGE: 'UPDATE_CURRENT_PRODUCT_PAGE',

	SET_CATALOG_VISIBLE_PRODUCT_SUCCESS: 'SET_CATALOG_VISIBLE_PRODUCT_SUCCESS',
	LOAD_MORE_PRODUCTS: 'LOAD_MORE_PRODUCTS',
}

const DIALOG_CONSTANTS = {
	TERMS_OPEN: 'DIALOG_OPEN_REQUEST',
	TERMS_CLOSE: 'DIALOG_CLOSE_REQUEST',

	MODAL_OPEN: 'MODAL_OPEN_REQUEST',
	MODAL_REOPEN: 'MODAL_REOPEN_REQUEST',
	MODAL_CLOSE: 'MODAL_CLOSE_REQUEST',

	PRODUCT_DETAIL_OPEN: 'PRODUCT_DETAIL_OPEN_REQUEST',
	PRODUCT_BUY_NOW_CLICKED: 'PRODUCT_BUY_NOW_CLICKED_REQUEST',
}

const ERROR_CONSTANTS = {
	SHOW_ACCESS_FORBIDDEN: 'SHOW_ACCESS_FORBIDDEN',

	ERROR: 'ERROR_SCREEN',
	MESSAGE: 'ERROR_MESSAGE',
}

const LANG_CONSTANTS = {
	LANGUAGE_POPUP_OPEN: 'LANGUAGE_POPUP_OPEN_REQUEST',
	LANGUAGE_POPUP_CLOSE: 'LANGUAGE_POPUP_CLOSE_REQUEST',

	CHANGE_LANGUAGE_LOCALE: 'CHANGE_LANGUAGE_LOCALE_REQUEST',

	SET_LANGUAGE_LOCALE: 'LANGUAGE_LOCALE_REQUEST',
	UPDATE_LANGUAGE_LOCALE: 'UPDATE_LANGUAGE_LOCALE_REQUEST',
}

const META_CONSTANTS = {
	SAVE_TOAST: 'SAVE_TOAST',
	SAVE_TRANSLATION: 'SAVE_TRANSLATION',
}

export {
	ALERT_CONSTANTS,
	CART_CONSTANTS,
	CONFIG_CONSTANTS,
	DIALOG_CONSTANTS,
	ERROR_CONSTANTS,
	LANG_CONSTANTS,
	META_CONSTANTS,
	PRODUCT_CONSTANTS,
	STORE_CONSTANTS,
}
